import { h } from 'preact';

import { Trans } from '@lingui/macro';

export const MetricsMenu = () => (
	<a href={'#/metrics'}><Trans>Metrics</Trans></a>
);
